import { type RouteRecordRaw, type Router } from 'vue-router'
import './route-types'

export function createSupportRoutes(
  startPath: string
): readonly RouteRecordRaw[] {
  return [
    {
      path: startPath,
      name: 'support',
      component: () => import('./views/SupportLayout.vue'),
      children: [
        {
          path: '',
          name: 'support.list',
          component: () => import('./views/SupportView.vue')
        }
      ]
    }
  ]
}

/**
 * Registers the Gatship-user-only assigned-sessions route under the
 * `/support` layout. Deliberately not part of `createSupportRoutes`:
 * the app calls this from session bootstrap after the user profile has
 * loaded, and only when the user is a Gatship support user — for
 * everyone else the route never exists, so direct navigation falls
 * through to the not-found catch-all.
 */
export function registerSupportAssignedRoute(router: Router) {
  router.addRoute('support', {
    path: 'assigned',
    name: 'support.assigned',
    component: () => import('./views/SupportSessionsAssignedView.vue')
  })
}
